import { ReactElement } from "react"
import { Link } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCloud, faFileExcel } from "@fortawesome/free-solid-svg-icons"

import { Button } from "@wfp/ui"

type Props = {
  moda: { path: string; text: string }
  excel: { path: string; text: string }
}

const NewDataContent = ({ moda, excel }: Props): ReactElement => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full p-4">
      <div className="group relative p-6 border-2 rounded-xl border-gray-100 border-solid h-[400px] flex flex-col justify-between hover:border-blue-500 hover:shadow-lg transition-all duration-300 cursor-pointer bg-gradient-to-br from-white to-blue-50">
        <div>
          <div className="bg-[var(--interactive-01)] w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
            <FontAwesomeIcon icon={faCloud} size="xl" className="text-white" />
          </div>
          <p className="text-xl font-bold mb-3 text-gray-900">MODA</p>
          <p className="text-sm text-gray-600 leading-relaxed">
            Import price data collected with the MODA application.
          </p>
        </div>
        <Link to={moda.path} className="w-full">
          <Button
            className="w-full group-hover:bg-[var(--interactive-01)] group-hover:text-white transition-colors"
            kind="secondary"
          >
            {moda.text}
          </Button>
        </Link>
      </div>

      <div className="group relative p-6 border-2 rounded-xl border-gray-100 border-solid h-[400px] flex flex-col justify-between hover:border-green-500 hover:shadow-lg transition-all duration-300 cursor-pointer bg-gradient-to-br from-white to-green-50">
        <div>
          <div className="bg-green-600 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
            <FontAwesomeIcon icon={faFileExcel} size="xl" className="text-white" />
          </div>
          <p className="text-xl font-bold mb-3 text-gray-900">Excel</p>
          <p className="text-sm text-gray-600 leading-relaxed">Upload a formatted Excel file with price data.</p>
        </div>
        <Link to={excel.path} className="w-full">
          <Button
            className="w-full group-hover:bg-green-600 group-hover:text-white transition-colors group-hover:border-green-600"
            kind="secondary"
          >
            {excel.text}
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default NewDataContent
